'use client';
import { createComponent } from "../internals/utils/index.js";
/**
 * The `Sidenav.Body` component for use with the `Sidenav` component.
 *
 * @see https://rsuitejs.com/components/sidenav
 */
var SidenavBody = createComponent({
  name: 'SidenavBody'
});
export default SidenavBody;